import React from 'react'
import { Col, Row, Typography } from 'antd'
import { s } from './style'
const { Text } = Typography

export const CostBlock: React.FC<{ title: string }> = ({ children, title }) => {
  return (
    <Row style={{ marginBottom: '10px' }}>
      <Col span={12}>
        <Text style={s.costLabels}>{title}</Text>
      </Col>
      <Col span={12}>
        <Text style={{ float: 'right', ...s.costLabels }}>{children}</Text>
      </Col>
    </Row>
  )
}

export const TotalBlock: React.FC<{ title: string }> = ({ children, title }) => {
  return (
    <Row style={{ marginBottom: '10px' }}>
      <Col span={12}>
        <Text style={s.totalLabel}>{title}</Text>
      </Col>
      <Col span={12}>
        <Text style={{ float: 'right', ...s.totalLabel }}>{children}</Text>
      </Col>
    </Row>
  )
}
